import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import nhSymbol from 'images/tmp_nh_symbol.png'
import wooriSymbol from 'images/tmp_woori_symbol.png'
import shSymbol from 'images/tmp_shinhan_symbol.png'
import styles from './index.module.css'

const DataDetail = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1">
				<div className={`${styles["count-group"]} padding`}>
					<p>개인신용정보 목록 선택</p>
					<div><span>1</span>/3</div>
				</div>
				<div className="padding pt_10">
					<ul className="check-area">
						<li>
							<div className="check-title">은행</div>
							<div className="check-list">
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={nhSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>전체자산</p>
											<span className="list-info">산업은행</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check1" name="check" />
										<label htmlFor="check1">
											<span></span>
										</label>
									</div>
								</div>
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={wooriSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>WELCOME 첫거래우대 M정기적금</p>
											<span className="list-info">우리은행 1234567891234</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check2" name="check" />
										<label htmlFor="check2">
											<span></span>
										</label>
									</div>
								</div>
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={shSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>듀얼K 입출금통장</p>
											<span className="list-info">케이뱅크 1234567891234</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check3" name="check" />
										<label htmlFor="check3">
											<span></span>
										</label>
									</div>
								</div>
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={nhSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>신한 주거래 우대통장(저축예금)</p>
											<span className="list-info">신한은행 1234567891234</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check4" name="check" />
										<label htmlFor="check4">
											<span></span>
										</label>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className="check-title">카드</div>
							<div className="check-list">
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={nhSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>NH농협카드</p>
											<span className="list-info">농협은행 1234567891234</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check5" name="check" />
										<label htmlFor="check5">
											<span></span>
										</label>
									</div>
								</div>
							</div>
						</li>
						<li>
							<div className="check-title">전자금융</div>
							<div className="check-list">
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={nhSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>페이코포인트</p>
											<span className="list-info">페이코 ej***@finger.co.kr</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check6" name="check" />
										<label htmlFor="check6">
											<span></span>
										</label>
									</div>
								</div>
								<div>
									<div>
										<div className="img-box img-symbol">
											<img src={wooriSymbol} alt="" />
										</div>
										<div className="ml_10">
											<p>페이코결제정보</p>
											<span className="list-info">페이코 ej***@finger.co.kr</span>
										</div>
									</div>
									<div className="chk">
										<input type="checkbox" id="check7" name="check" />
										<label htmlFor="check7">
											<span></span>
										</label>
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">다음</Button>
			</div>
		</div>
	)
}

export default DataDetail